const urlName = '/course/v1'
export default API => ({
    // 
    getAliyunConf() {
        return API({ url: '/resource/v1/resource/getUpFloadFileVoucher', method:  'post' })
    },
   
    // 查询课程关联作业列表
    // 作业入口查询作业列表
    findHomeworkListById(params) {
        return API({
            url: `${urlName}/open/homework/findByCourseId`,
            method: 'get',
            params, 
        })
    },
    // 
    // 写作业-作业作答
    answerHomework(data) {
        return API({
            url: `${urlName}/open/homework/answerHomework`,
            method: 'post',
            data, 
        })
    },
    // 查看作业/查看点评
    findHomework(params) {
        return API({
            url: `${urlName}/open/homework/findHomework`,
            method: 'get',
            params, 
        })
    },
    // // 查询作业信息
    // findHomeworkById(params) {
    //     return API({
    //         url: `${urlName}/admin/homework/findHomeworkById`,
    //         method: 'get',
    //         params, 
    //     })
    // }
     // scrom素材预览 ----开始
     getScormInfoById(params){
        return API({ url: `/resource/v1/resource/getScormInfoById?resId=${params.id}`})
    },
})